import styled from 'styled-components';

export const OnBoardingContainerStyled = styled.div`
  display: flex;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
  }
`;
